export default "__VITE_ASSET__DuRo6eiD__"